'use client';

import { ErrorSurface } from '@/components/layout/error-surface';

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <ErrorSurface
      title="Dashboard konnte nicht vollständig geladen werden"
      message="Mindestens ein Bereich des Beschaffungsagenten hat beim Rendern oder Laden der Daten einen Fehler ausgelöst. Die Oberfläche bleibt in einem sicheren Fallback statt in einem weißen Screen."
      error={error}
      onRetry={reset}
    />
  );
}